import React from 'react';
import { observer } from 'mobx-react-lite';
import { IMInputText, IMSelect, OverlaySpinner } from '@insurancemenu/imenu-components-lib';
import { useAddEmployeeViaFormPageStore } from 'store/pages/utility/add-employee-via-form/pageStore';
import NavigationActionFooter from 'components/common/general/NavigationActionFooter';
import {
  ADD_EMPLOYEE_GUIDELINES_NEW_INVITE_TEST_ID,
  ADD_EMPLOYEE_GUIDELINES_USER_IN_SYSTEM_TEST_ID,
} from './constants';
import { GuidelinesStyled, IMFormStyled } from './styles';

const AddEmployeeForm: React.FC = observer(() => {
  const {
    formController,
    isLoading,
    isFormValid,
    isUserInTheSystem,
    saveAndReturnToList,
    saveAndAddNewEmployee,
    returnBack,
  } = useAddEmployeeViaFormPageStore();

  return (
    <>
      <GuidelinesStyled $isUserInTheSystem={isUserInTheSystem}>
        {isUserInTheSystem ? (
          <span data-test-id={ADD_EMPLOYEE_GUIDELINES_USER_IN_SYSTEM_TEST_ID}>
            This employee <b> has already been invited and is in the system.</b>
            <br /> They&apos;ll be able to sign in once registration is complete.
          </span>
        ) : (
          <span data-test-id={ADD_EMPLOYEE_GUIDELINES_NEW_INVITE_TEST_ID}>
            We only collect the minimum information needed to send the employee&apos;s invitation. <br /> They&apos;ll
            <b> receive an email </b> with a link to complete their registration.
          </span>
        )}
      </GuidelinesStyled>

      <IMFormStyled formController={formController} id="add-employee-form">
        <IMInputText name="firstName" label="First Name" $size="m" />
        <IMInputText name="lastName" label="Last Name" $size="m" />
        <IMInputText name="email" label="Email" $size="m" />
        <IMInputText name="dob" label="Date of Birth" $size="m" htmlType="date" />
        <IMSelect
          name="invite"
          label="Invite"
          $size="m"
          options={[
            { label: 'Yes', value: 'true' },
            { label: 'No', value: 'false' },
          ]}
        />
        <OverlaySpinner display={isLoading} data-test-id="self-registration-form-spinner-test-id" />
      </IMFormStyled>
      <NavigationActionFooter
        isFormValid={isFormValid}
        back={{
          text: 'Back to all employees',
          handler: returnBack,
        }}
        saveAndReturn={{
          text: 'Save & Return to List',
          handler: saveAndReturnToList,
        }}
        saveAndContinue={{
          text: 'Save & Add New',
          handler: saveAndAddNewEmployee,
        }}
      />
    </>
  );
});

export default AddEmployeeForm;
